// Add your custom JS here.

(function($) {

  // navigation dropdown hover
  document.addEventListener("DOMContentLoaded", function(){
    if (window.innerWidth > 1200) {
    
      document.querySelectorAll('.navbar .nav-item').forEach(function(everyitem){
    
        everyitem.addEventListener('mouseover', function(e){
    
          let el_link = this.querySelector('a[data-bs-toggle]');
    
          if(el_link != null){
            let nextEl = el_link.nextElementSibling;
            el_link.classList.add('show');
            nextEl.classList.add('show');
          }
    
        });
        everyitem.addEventListener('mouseleave', function(e){
          let el_link = this.querySelector('a[data-bs-toggle]');
    
          if(el_link != null){
            let nextEl = el_link.nextElementSibling;
            el_link.classList.remove('show');
            nextEl.classList.remove('show');
          }
    
    
        })
      });
    
    }
  }); 

  
  //to-top
  $(function() {
      let showFlag = false;
      const topBtn = $('.to-top');    
      topBtn.css('bottom', '-100px');
      //スクロールが100に達したらボタン表示
      $(window).on('scroll', function () {
          if ($(this).scrollTop() > 100) {
              if (showFlag == false) {
                  showFlag = true;
                  topBtn.stop().animate({'bottom' : '40px'}, 200); 
              }
          } else {
              if (showFlag) {
                  showFlag = false;
                  topBtn.stop().animate({'bottom' : '-100px'}, 200); 
              }
          }
      });

      topBtn.on('click', function(){
        $('body,html').animate({
          scrollTop: 0},500);
          return false;
      });
        
  });

  
  // スムーススクロール
  // headerの高さを取得し、headeHeightに代入
  const headerHeight = document.getElementById('main-nav').offsetHeight;

  //querySelectorAllメソッドを使用してページ内のhref属性が#で始まるものを選択
  //forEachメソッドを使って、各アンカータグにクリックされた時の処理
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {

      // クリックされたときのデフォルトの挙動を防ぐ
      e.preventDefault();

      // クリックされたアンカータグのhref属性を取得
      const href = anchor.getAttribute('href');

      // href属性の#を取り除いた部分と一致するIDを取得
      const target = document.getElementById(href.replace('#', ''));

      if(target !== null){
        //取得した要素の位置を取得するために、getBoundingClientRect()を呼び出し、ページ上の位置を計算。
        //headerの高さを引いて、スクロール位置がヘッダーの下になるように調整します。
        const targetPosition = target.getBoundingClientRect().top + window.scrollY - headerHeight;

        // window.scrollTo()を呼び出して、スクロール位置を設定します。behaviorオプションをsmoothに設定することで、スムーズなスクロールを実現します。
        window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
        });
      }
    });
  });

  // スムーススクロール ページ外
  document.addEventListener("DOMContentLoaded", () => {
    if (location.hash) {
      const headerHeight = document.getElementById("main-nav").clientHeight;
      setTimeout(() => {
        window.scrollBy(0, - headerHeight);
      },100)
    }
  })





// product side popup
$(function() {
  const popup_btn = $('.product-side-popup-btn');
  const popup_target = $('#product-side-popup');
  const popup_close = popup_target.find('.btn-close');
  if(popup_btn){
    popup_btn.on('click', function(){
      popup_target.toggle();
    })

    popup_close.on('click', function(){
      popup_target.hide();
    })
  }
})

//// woocommerce

// 商品詳細ページで合計金額を表示する
// 平板（uni cpo）
$(function() {
  const single_product_container = $('.cpo-enabled-product .summary.entry-summary');
  const single_product_price_total = single_product_container.find('.price-total .price-total-amount');
  if(single_product_price_total){
    $(window).on('uni_cpo_set_price_event', function(){
      let unit_price = single_product_container.find('.price bdi').text().replace(/[^0-9]/g, '');
      let qty = single_product_container.find('[name="quantity"]').val();
      unit_price = Number(unit_price);
      qty = Number(qty);
      if(unit_price > 0){
        let total_price = unit_price * qty;
        single_product_price_total.text(total_price.toLocaleString('ja-JP'));
      }
    })
  }
})

// 波板（variation）
$(function() {
  const single_product_container = $('.single_variation_wrap');
  const qty_input = single_product_container.find('[name="quantity"]');
  if(single_product_container){
    $(window).on('change', qty_input, function(){
      let single_product_price_total = single_product_container.find('.price-total .price-total-amount');
      let unit_price = single_product_container.find('.price bdi').text().replace(/[^0-9]/g, '');
      let qty = qty_input.val();
      unit_price = Number(unit_price);
      qty = Number(qty);
      if(unit_price > 0){
        let total_price = unit_price * qty;
        single_product_price_total.text(total_price.toLocaleString('ja-JP'));
      }
    })
  }
})


// マイアカウントで請求書・領収書印刷ボタンを両方表示
$(function() {
  const print_button = $('a.button.print');
  if(print_button){
    print_button.each(function(index) {
      const href = $(this).attr('href');
      if(href.indexOf('print-order-type=invoice') >= 0) {
        $(this).text('請求書');
      } else if(href.indexOf('print-order-type=receipt') >= 0) {
        $(this).text('領収書');
        const new_url = href.replace('print-order-type=receipt', 'print-order-type=invoice');
        const new_obj = $(this).clone(true).attr('href', new_url).html('請求書');
        $(this).before(new_obj);
      }
    });
  }
})


// チェックアウト w4jp 配達希望日時スタイル
$(function() {
  $('#wc4jp_delivery_date, #wc4jp_delivery_time_zone').addClass('form-select');
})

})(jQuery);
